"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.importItems = exports.search = exports.update = exports.create = exports.fetch = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const itemsService_1 = require("./service/itemsService");
const Env_1 = require("../../utils/tsUtils/Env");
exports.fetch = (0, toolkit_1.createAsyncThunk)('items/fetch', (payload) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const itemsService = new itemsService_1.ItemsService(Env_1.APIPATHENV);
        const response = yield itemsService.fetchItems(payload);
        return response;
    }
    catch (error) {
        throw new Error("Error in fetching items");
    }
}));
exports.create = (0, toolkit_1.createAsyncThunk)('items/create', (payload) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const itemsService = new itemsService_1.ItemsService(Env_1.APIPATHENV);
        const response = yield itemsService.createItem(payload);
        return response;
    }
    catch (error) {
        throw new Error("Error in creating item");
    }
}));
exports.update = (0, toolkit_1.createAsyncThunk)('items/update', (payload) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const itemsService = new itemsService_1.ItemsService(Env_1.APIPATHENV);
        const response = yield itemsService.updateItem(payload);
        return response;
    }
    catch (error) {
        throw new Error("Error in updating item");
    }
}));
exports.search = (0, toolkit_1.createAsyncThunk)('items/search', (payload) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const itemsService = new itemsService_1.ItemsService(Env_1.APIPATHENV);
        const response = yield itemsService.searchItems(payload);
        return response;
    }
    catch (error) {
        throw new Error("Error in searching items");
    }
}));
exports.importItems = (0, toolkit_1.createAsyncThunk)('items/import', (payload) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const itemsService = new itemsService_1.ItemsService(Env_1.APIPATHENV);
        const response = yield itemsService.importItems(payload);
        return response;
    }
    catch (error) {
        throw new Error("Error in importing items");
    }
}));
